import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Task } from 'gql/graphql';
import CreateLoanDoc from './CreateLoanDoc';
import iconDonwloadSvg from 'assets/images/icon-download.svg';
import DocumentItem from './Shared/components/DocumentItem';
import { useLoanDocuments } from './useLoanDocuments';

interface ILoanDocumentsProps {
  tasks: Task[];
  setAllDocsComplete: Function;
  handlerOpenTask: Function;
}

const LoanDocuments: React.FC<ILoanDocumentsProps> = (props) => {
  const {
    loanDocumentsStatic,
    selectLoanDoc,
    setSelectLoanDoc,
    loadingDonwload,
    loanDocs,
    newLoanDocs,
    loanGuarantorsFiltered,
    getStateLoanDoc,
    isBoxInfo,
    handlerOnBlocking,
    isFile,
    downloadFile,
    downloadAllDocuments,
    onDeleteLoanDocument,
    handlerSelectLoanDoc,
    getExpirationLoanDoc,
  } = useLoanDocuments({
    tasks: props.tasks,
    setAllDocsComplete: props.setAllDocsComplete,
  });

  return (
    <div className='loan-documents'>
      <div className='title'>
        Loan Documents
      </div>
      <CreateLoanDoc 
        selectLoanDoc={selectLoanDoc} 
        setSelectLoanDoc={setSelectLoanDoc} 
        loanDocs={loanDocs || []} 
        handlerOpenTask={props.handlerOpenTask}
      />
      <div className='loan-documents-docs-actions'>
        <div onClick={downloadAllDocuments}>
          {loadingDonwload && <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />}
          {!loadingDonwload && <img alt="download" src={iconDonwloadSvg} />}
          DOWNLOAD ALL
        </div>
      </div>
      <div className='loan-documents-list'>
        {loanDocumentsStatic.filter((doc) => !doc.isDelete).map((loanDoc: any, index) => (
          <DocumentItem
            key={index}
            docKey={loanDoc.key}
            label={loanDoc.label}
            onSelect={handlerSelectLoanDoc}
            onDelete={onDeleteLoanDocument}
            state={getStateLoanDoc(loanDoc)}
            expiration={getExpirationLoanDoc(loanDoc)}
            handlerOnBlocking={handlerOnBlocking}
            handlerDownloadFile={() => downloadFile(loanDoc)}
            isDownload={!!isFile(loanDoc)}
            documentCanBeDeleted={false}
            boxInfo={loanDoc.key === "insurance" && getStateLoanDoc(loanDoc) === 'MANUAL ACTION' ?
              <div className="box-message-state-review">
                {isBoxInfo(loanDoc, props.handlerOpenTask)}
              </div>
              : null
            }
          />
        ))}
        {newLoanDocs?.map((loanDoc: any, index) => (
          <DocumentItem
            key={index}
            docId={loanDoc._id}
            label={loanDoc.name}
            onSelect={handlerSelectLoanDoc}
            onDelete={onDeleteLoanDocument}
            state={getStateLoanDoc(loanDoc)}
            handlerOnBlocking={handlerOnBlocking}
            handlerDownloadFile={() => downloadFile(loanDoc)}
            isDownload={!!isFile(loanDoc)}
            expiration={getExpirationLoanDoc(loanDoc)}
            documentCanBeDeleted={true}
          />
        ))}
        {loanGuarantorsFiltered.map((loanDoc: any, index: number) => (
          <DocumentItem
            key={index}
            docId={loanDoc._id}
            label={loanDoc.name}
            onSelect={handlerSelectLoanDoc}
            onDelete={onDeleteLoanDocument}
            state={getStateLoanDoc(loanDoc)}
            expiration={getExpirationLoanDoc(loanDoc)}
            handlerOnBlocking={handlerOnBlocking}
            handlerDownloadFile={() => downloadFile(loanDoc)}
            isDownload={!!isFile(loanDoc)}
            documentCanBeDeleted={true}
          />
        ))}
      </div>
    </div>
  );
};

export default LoanDocuments;